









export enum ParameterTypeName {

	PARAM_VC = "Vc",

	PARAM_IVC = "Ivc",

	PARAM_FVC = "Fvc",

	PARAM_FEV05 = "Fev05",

	PARAM_FEV05FVC = "Fev05Fvc",

	PARAM_FEV075 = "Fev075",

	PARAM_FEV075FVC = "Fev075Fvc",

	PARAM_FEV1 = "Fev1",

	PARAM_FEV1VC = "Fev1Vc",

	PARAM_FEV1R = "Fev1R",

	PARAM_FEV1FVC = "Fev1Fvc",

	PARAM_FEV1PEF = "Fev1Pef",

	PARAM_FEV3 = "Fev3",

	PARAM_FEV3VC = "Fev3Vc",

	PARAM_FEV3FVC = "Fev3Fvc",

	PARAM_FEV6 = "Fev6",

	PARAM_FEV6FVC = "Fev6Fvc",

	PARAM_PEFSEC = "PefSec",

	PARAM_PEFMIN = "PefMin",

	PARAM_FEF0212 = "Fef0212",

	PARAM_FEF2575 = "Fef2575",

	PARAM_FEF2575FVC = "Fef2575Fvc",

	PARAM_FEF7585 = "Fef7585",

	PARAM_FEF25 = "Fef25",

	PARAM_FEF50 = "Fef50",

	PARAM_FEF75 = "Fef75",

	PARAM_FIVC = "Fivc",

	PARAM_FIVCFVC = "FivcFvc",

	PARAM_FIV1 = "Fiv1",

	PARAM_PIFSEC = "PifSec",

	PARAM_PIFMIN = "PifMin",

	PARAM_FIF25 = "Fif25",

	PARAM_FIF50 = "Fif50",

	PARAM_FIF75 = "Fif75",

	PARAM_FIF50FEF50 = "Fif50Fef50",

	PARAM_MVVIND = "MvVind",

	PARAM_FMFT = "Fmft",

	PARAM_FET = "Fet",

	PARAM_EV = "Bev",

	PARAM_VEXTFVC = "BevFvc",

	PARAM_FRC = "Frc",

	PARAM_TV = "Tv",

	PARAM_RV = "Rv",

	PARAM_TLC = "Tlc",

	PARAM_IRV = "Irv",

	PARAM_ERV = "Erv",

	PARAM_IC = "Ic",

	PARAM_FEV1HT2 = "Fev1Ht2",

	PARAM_RAWIND = "Rawind",

	PARAM_TPEF = "Tpef",

	PARAM_TEXT = "Text",

	PARAM_EOTV = "Eotv",

	PARAM_FEV1FIVC = "Fev1Fivc",

	PARAM_FEV1IVC = "Fev1Ivc",

	PARAM_FIV1FIVC = "Fiv1Fivc",

	PARAM_FIV1FVC = "Fiv1Fvc",

	PARAM_FEV1FEV6 = "Fev1Fev6",

	PARAM_PCFSEC = "PcfSec",

	PARAM_PCFMIN = "PcfMin",

	PARAM_VIMAXT = "ViMaxT",

	PARAM_VIMAXFVC = "ViMaxFvc",

	PARAM_IFR = "Ifr",

	PARAM_HR = "HeartRate",

	PARAM_QTCFRI = "QTcFri",

	PARAM_QTCFRA = "QTcFra",

	PARAM_QTCBAZ = "QTcBaz",

	PARAM_QTCHOD = "QTcHod",

	PARAM_FEF50FIF50 = "Fef50Fif50",

	PARAM_DLCO = "DLco",

	PARAM_BHT = "Bht",

	PARAM_IV = "Iv",

	PARAM_KCO = "Kco",

	PARAM_VA = "Va",

	CHPARAM_MEAS = "Measured",

	CHPARAM_DOSE = "Dose",

	CHPARAM_DILUENT_FALL = "FallFromDiluent",

	CHPARAM_BASELINE_FALL = "FallFromBaseline",

	CHPARAM_PERC_BASELINE = "PercentageBaseline",

	CHPARAM_PERC_DILUENT = "PercentageDiluent",

	CHPARAM_DOSE_TARGET = "DoseTarget",

	CHPARAM_PC20 = "Pc20",

	CHPARAM_REVERSE_BASELINE = "ReversePercentageBaseline",

	CHPARAM_EXERCISE = "Exercise",

	CHPARAM_EXERCISE_TARGET = "ExerciseTarget",

	PARAM_SYSTOLIC = "Systolic",

	PARAM_DIASTOLIC = "Diastolic",

	PARAM_MAP = "MeanArterialPressure",

	PARAM_1FEV3FVC = "C1Fev3Fvc",

	PARAM_QTCRAU = "QTcRau",

	PARAM_PR = "PR",

	PARAM_QRS = "QRS",

	PARAM_QT = "QT",

	PARAM_RR = "RR",

	PARAM_JT = "JT",

	PARAM_ST = "ST",

	PARAM_QTP = "QTp",

	PARAM_TPTE = "TpTe",

	PARAM_QDUR = "Qdur",

	PARAM_RDUR = "Rdur",

	PARAM_SDUR = "Sdur",

	PARAM_STAMP = "STamp",

	PARAM_QAMP = "Qamp",

	PARAM_TAMP = "Tamp",

	PARAM_RAMP = "Ramp",

	PARAM_PAMP = "Pamp",

	PARAM_SAMP = "Samp",

	PARAM_PDUR = "Pdur",

	PARAM_EVC = "Evc",

	PARAM_BLOOD_GLUCOSE_SI = "BloodGlucoseSI",

	PARAM_BLOOD_KETONE = "BloodKetone",

	PARAM_BLOOD_GLUCOSE_US = "BloodGlucoseUS",

	PARAM_DLCO_CORR = "DLcoCorr",

	PARAM_IVFVC = "IvFvc",

	PARAM_DLCO_OVER_HIGHEST = "DLcoOverHighestDLco",

	PARAM_DLCO_WITHIN_TOLERANCE = "DLcoTestsWithinTolerance",

	PARAM_FVC_OVER_BEST = "FvcFvcBest",

	PARAM_FEV1_OVER_BEST = "Fev1Fev1Best",

	PARAM_PEF_OVER_BEST = "PefPefBest",

	PARAM_FEV1EVC = "Fev1Evc",

	PARAM_YEARS = "LungAge",

	PARAM_TIDAL_PEF = "TidalPef",

	PARAM_RISETIME = "RiseTime",

	PARAM_THES = "THes",

	PARAM_TZERO = "TZero",

	PARAM_PQ = "PQ",

	PARAM_RVTLC = "RvTlc",

	PARAM_IC_OBTAINED = "IcObtained",

	PARAM_IC_OBTAINED_PERCENT = "IcObtainedPercent",

	PARAM_VC_OBTAINED = "VcObtained",

	PARAM_OTHER_TESTS_WITHIN_ERV_TOLERANCE = "OtherTestsWithinERVTolerance",

	PARAM_FRC_VARIANCE_PERCENT = "FrcVariance",

	PARAM_PAXIS = "PAxis",

	PARAM_QRSAXIS = "QRSAxis",

	PARAM_TAXIS = "TAxis",

	PARAM_MIPMEP_REPEAT_PERCENT = "MipMepRepeatabilityPercent",

	PARAM_SNIP_REPEAT_PERCENT = "SnipRepeatabilityPercent",

	PARAM_MIP = "Mip",

	PARAM_PIP = "Pip",

	PARAM_MEP = "Mep",

	PARAM_PEP = "Pep",

	PARAM_SNIP = "Snip",

	PARAM_MIPMEP_REPEAT = "MipMepRepeatability",

	PARAM_VC_OVER_BEST = "VcVcBest",

	PARAM_SNIP_REPEAT = "SnipRepeatability",

	PARAM_OSCILLOMETRY_R5 = "R5",

	PARAM_OSCILLOMETRY_R20 = "R20",

	PARAM_OSCILLOMETRY_R520 = "R5R20",

	PARAM_OSCILLOMETRY_R7 = "R7",

    PARAM_OSCILLOMETRY_R720 = "R7R20",

	PARAM_OSCILLOMETRY_X5 = "X5",

	PARAM_OSCILLOMETRY_AX = "Ax",

	PARAM_FVC_FEFMAX = "FefMax",

	PARAM_FVC_EVFVC = "EvFvc",

	PARAM_BLOOD_PRESSURE = "Bp",

	PARAM_SPO2_MIN = "SpO2Min",

	PARAM_SPO2_MAX = "SpO2Max",

	PARAM_SPO2_MEDIAN = "SpO2Median",

	PARAM_BPM_MIN = "BpMin",

	PARAM_BPM_MAX = "BpMax",

	PARAM_BPM_MEAN = "BpMean",

	PARAM_SPO2_PERCENT = "SpO2Percent",

	PARAM_SPO2_PERCENT_COMPLETE = "SpO2PercentComplete",

	PARAM_FVC_ABSOLUTE_REPEATABILITY = "FvcAbsoluteRepeatability",

	PARAM_FEV1_ABSOLUTE_REPEATABILITY = "Fev1AbsoluteRepeatability",

    PARAM_PEF_ABSOLUTE_REPEATABILITY = "PefMinAbsoluteRepeatability",

    PARAM_MVV = "MVV",

    PARAM_OSCILLOMETRY_FRES = "Fres",

    PARAM_FEV1Q = "Fev1Q",

    PARAM_FEVBDR = "Fev1Bdr",

    PARAM_FVCBDR = "FvcBdr"
}

export enum ParameterType {

	Vc = 1,

	Ivc = 2,

	Fvc = 3,

	Fev05 = 4,

	Fev05Fvc = 5,

	Fev075 = 6,

	Fev075Fvc = 7,

	Fev1 = 8,

	Fev1Vc = 9,

	Fev1R = 10,

	Fev1Fvc = 11,

	Fev1Pef = 12,

	Fev3 = 13,

	Fev3Vc = 14,

	Fev3Fvc = 15,

	Fev6 = 16,

	Fev6Fvc = 17,

	PefSec = 18,

	PefMin = 19,

	Fef0212 = 20,

	Fef2575 = 21,

	Fef2575Fvc = 22,

	Fef7585 = 23,

	Fef25 = 24,

	Fef50 = 25,

	Fef75 = 26,

	Fivc = 27,

	FivcFvc = 28,

	Fiv1 = 29,

	PifSec = 30,

	PifMin = 31,

	Fif25 = 32,

	Fif50 = 33,

	Fif75 = 34,

	Fif50Fef50 = 35,

	MvVind = 36,

	Fmft = 37,

	Fet = 38,

	Bev = 39,

	BevFvc = 40,

	Frc = 41,

	Tv = 42,

	Rv = 43,

	Tlc = 44,

	Irv = 45,

	Erv = 46,

	Ic = 47,

	Fev1Ht2 = 48,

	Rawind = 49,

	Tpef = 50,

	Text = 51,

	Eotv = 52,

	Fev1Fivc = 53,

	Fev1Ivc = 54,

	Fiv1Fivc = 55,

	Fiv1Fvc = 56,

	Fev1Fev6 = 57,

	PcfSec = 58,

	PcfMin = 59,

	ViMaxT = 60,

	ViMaxFvc = 61,

	Ifr = 62,

	HeartRate = 63,

	QTcFri = 64,

	QTcFra = 65,

	QTcBaz = 66,

	QTcHod = 67,

	Fef50Fif50 = 68,

	DLco = 69,

	Bht = 70,

	Iv = 71,

	Kco = 72,

	Va = 73,

	Measured = 75,

	Dose = 76,

	FallFromDiluent = 77,

	FallFromBaseline = 78,

	PercentageBaseline = 79,

	PercentageDiluent = 80,

	DoseTarget = 81,

	Pc20 = 82,

	ReversePercentageBaseline = 83,

	Exercise = 84,

	ExerciseTarget = 85,

	Systolic = 86,

	Diastolic = 87,

	MeanArterialPressure = 88,

	C1Fev3Fvc = 89,

	QTcRau = 90,

	PR = 91,

	QRS = 92,

	QT = 93,

	RR = 94,

	JT = 95,

	ST = 96,

	QTp = 97,

	TpTe = 98,

	Qdur = 99,

	Rdur = 100,

	Sdur = 101,

	STamp = 102,

	Qamp = 103,

	Tamp = 104,

	Ramp = 105,

	Pamp = 106,

	Samp = 107,

	Pdur = 108,

	Evc = 109,

	BloodGlucoseSI = 110,

	BloodKetone = 111,

	BloodGlucoseUS = 112,

	DLcoCorr = 113,

	IvFvc = 114,

	DLcoOverHighestDLco = 115,

	DLcoTestsWithinTolerance = 116,

	FvcFvcBest = 117,

	Fev1Fev1Best = 118,

	PefPefBest = 119,

	Fev1Evc = 120,

	LungAge = 121,

	TidalPef = 122,

	RiseTime = 123,

	THes = 124,

	TZero = 125,

	PQ = 126,

	RvTlc = 127,

	IcObtained = 128,

	IcObtainedPercent = 129,

	VcObtained = 130,

	OtherTestsWithinERVTolerance = 131,

	FrcVariance = 132,

	PAxis = 133,

	QRSAxis = 134,

	TAxis = 135,

	MipMepRepeatabilityPercent = 139,

	SnipRepeatabilityPercent = 140,

	Mip = 141,

	Pip = 142,

	Mep = 143,

	Pep = 144,

	Snip = 145,

	MipMepRepeatability = 146,

	VcVcBest = 147,

	SnipRepeatability = 148,

	R5 = 149,

	R20 = 150,

	R5R20 = 151,

	Ax = 152,

	FefMax = 153,

	EvFvc = 154,

	Bp = 155,

	SpO2Min = 156,

	SpO2Max = 157,

	SpO2Median = 158,

	BpMin = 159,

	BpMax = 160,

	BpMean = 161,

	SpO2Percent = 162,

	SpO2PercentComplete = 163,

	FvcAbsoluteRepeatability = 164,

	Fev1AbsoluteRepeatability = 165,

	PefMinAbsoluteRepeatability = 166,

    R7 = 167,

    R7R20 = 168,

    MVV = 169,

    Fres = 170,

    Fev1Q = 171,

    Fev1Bdr = 172,

    FvcBdr = 173
}
